import { modifyPointCloud } from "api/timeline";
import { getPointCloudData } from "pages/unity/domain/getPointCloudData";
import { getPointCloudbyId } from "api/timeline";
import { deletePointCloud, refreshProcessing, getProjectDatesInfo, rerunProcessing } from "api/pointCloud";
import colorDropdownConfig from "./colorDropdownConfig";

const projectDateConfig = {
  getPointCloudData,
  deletePointCloud,
  modifyPointCloud,
  colorDropdownConfig,
  refreshProcessing,
  getPointCloudbyId,
  getProjectDatesInfo,
  rerunProcessing
};

export default projectDateConfig;